/*
 * Copyright (c) 2020. Legalbird eine Marke der R&S Internet Jewels GmbH
 */

import React from "react";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import _map from "lodash/map";
import ReactGA from "react-ga4";
import AccordionSummary from "@mui/material/AccordionSummary";
import Accordion from "@mui/material/Accordion";
import AccordionDetails from "@mui/material/AccordionDetails";
import { controlledAccordionSchufaStyles } from "./controlledAccordionSchufaStyles";
import { Box } from "@mui/material";
import { AccordionContent } from "../../../../../../types/AccordionContent";

export interface ControlledAccordionSchufaProps {
  contentList: AccordionContent[];
  idPrefix: string;
  name: string;
}

export default function ControlledAccordionSchufa({ contentList, idPrefix, name }: ControlledAccordionSchufaProps) {
  const [expanded, setExpanded] = React.useState<string | false>(false);

  const handleChange = (panelName: string, accordionName: string, heading: string) => (event: React.SyntheticEvent, isExpanded: boolean) => {
    setExpanded(isExpanded ? panelName : false);
    ReactGA.event({
      category: "Accordion " + accordionName,
      action: "Click",
      label: heading,
    });
  };

  return (
    <Box id={idPrefix + "-accordion"}>
      {_map(contentList, (content) => {
        let panelName = "panel" + content.id;
        return (
          <Accordion key={panelName} expanded={expanded === panelName} onChange={handleChange(panelName, name, content.heading)}>
            <AccordionSummary expandIcon={<ExpandMoreIcon />} id={panelName + "-header"}>
              <Box sx={controlledAccordionSchufaStyles.heading}>{content.heading}</Box>
            </AccordionSummary>
            <AccordionDetails>{content.text}</AccordionDetails>
          </Accordion>
        );
      })}
    </Box>
  );
}
